export const FETCH_CONTENT_REQUEST = 'contentfulPreview/FETCH_CONTENT_REQUEST';
export const FETCH_CONTENT_SUCCESS = 'contentfulPreview/FETCH_CONTENT_SUCCESS';
export const FETCH_CONTENT_FAILURE = 'contentfulPreview/FETCH_CONTENT_FAILURE';

export const LAYOUT_PREVIEW_KEY = 'preview';
